"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=penalty.js.map